import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { css } from "styled-components";

headerStyles.saveButton = {
    css: css`
        margin-left: 10px;
        span {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 2px;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            text-transform: uppercase;
        }
    `,
}

headerStyles.buttonSet = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 4, 3, 3],
}

headerStyles.titleWrapper = {
    width: [10, 10, 8, 9, 9],
}

headerStyles.overflowMenu = {
    cssOverrides:{
        wrapper:css`
            span {
                color: #FFFFFF !important;
            }
            ul {
                background:  #FFFFFF !important;
            }
        `,
    }
}